<div class="assessment-container">
  <assessment-row title="Pain Rating" [historyMode]="true">
    <p>{{ data().painRating }}</p>
  </assessment-row>

  <assessment-row title="Pain Scale" [historyMode]="true">
    <p>{{ data().painScale }}</p>
  </assessment-row>

  <assessment-row title="Pain Location" [historyMode]="true">
    <p>{{ data().painLocation }}</p>
  </assessment-row>

  <assessment-row title="Pain Quality" [historyMode]="true">
    <p>{{ data().painQuality }}</p>
  </assessment-row>

  <assessment-row title="Pain Quality Description" [historyMode]="true">
    <p>{{ data().painQualityOther }}</p>
  </assessment-row>

  <assessment-row title="Other Findings" [historyMode]="true">
    <p>{{ data().otherFindings }}</p>
  </assessment-row>

  @if (patient().isObstetric()) {
  @if (data().hasIntrapartumPain) {
  <hr class="section-divider" />
  <h2>Intrapartum Pain Assessment</h2>

  <assessment-row title="Analgesia" [historyMode]="true">
    <p>{{ data().hasAnalgesia | booleanToYesNo }}</p>
  </assessment-row>

  @if (data().hasAnalgesia) {
  <div class="nested-section">
    <assessment-row title="Epidural" [historyMode]="true">
      <p>{{ data().hasEpiduralPresent | booleanToYesNo }} </p>
    </assessment-row>
    <assessment-row title="Nitrous Oxide" [historyMode]="true">
      <p>{{ data().nitrousOxide | booleanToYesNo }}</p>
    </assessment-row>
    <assessment-row title="Opioids" [historyMode]="true">
      <p>{{ data().opioids | booleanToYesNo }}</p>
    </assessment-row>
    <assessment-row title="Other" [historyMode]="true">
      <p>{{ data().analgesiaOther }} </p>
    </assessment-row>
  </div>
  }
  }

  <h2>Non-Pharmacologic Interventions</h2>
  <assessment-row title="Walking?" [historyMode]="true">
    <p>{{ data().isWalking | booleanToYesNo }} </p>
  </assessment-row>
  <assessment-row title="Position Change" [historyMode]="true">
    <p>{{ data().positionChange }}</p>
  </assessment-row>
  <assessment-row title="Birthing Ball?" [historyMode]="true">
    <p>{{ data().hasBirthingBall | booleanToYesNo }}</p>
  </assessment-row>
  <assessment-row title="Warm Bath?" [historyMode]="true">
    <p>{{ data().warmBath }} </p>
  </assessment-row>
  <assessment-row title="Other" [historyMode]="true">
    <p>{{ data().nonPharmacologicOther }}</p>
  </assessment-row>
  }
</div>